import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-BrandOverview",
  "use": "icon-BrandOverview-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-BrandOverview\">\n<path d=\"M12.0008 0.630341L14.9034 8.9809L23.7422 9.16102L16.6973 14.5021L19.2574 22.964L12.0008 17.9143L4.74412 22.964L7.30416 14.5021L0.259277 9.16102L9.0981 8.9809L12.0008 0.630341Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol